import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Loader from "./Loader";
const Fortest2 = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  const Textstyle = {
    fontSize: "22px",
    lineHeight: "28px",
    fontWeight: "500",
    color: "#222c5a",
  };
  const StyledHeading = styled.h6`
    position: relative;
    font-size: 100px;
    color: #008bcd;

    &::before {
      content: "—";
      font-size: inherit;
      color: #008bcd;
      display: block;
    }
  `;

  return (
    <div>
    {/**
     <div>
        <Header />
      </div>
     */}
     
      <Loader isVisible={isVisible} />
  
<section className="page-section-ptb">
  <div className="container">
   {/** <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-left">
              <h2 className="title-effect " >Accélérer la transition énergétique avec des solutions robustes et sur mesure.</h2>
            </div>
          </div>
        </div> */}
    <div className="row">
      <div className="col-lg-6">
        <div className="who-we-are-left">
          <div className="owl-carousel" data-nav-dots="true" data-items={1} data-md-items={1} data-sm-items={1} data-xs-items={1} data-xx-items={1}>
            <div className="item"><img className="img-fluid full-width" src="/assets/images/slider_bannier/PSLIDER10.png" alt />
            </div>
           
            
          </div>
        </div>
      </div>
      <div className="col-lg-6 sm-mt-30">
      
        <div className="section-title" style={{marginBottom:"0px"}}>
          <h4>Accélérer la transition énergétique avec des solutions robustes et sur mesure.</h4>
          {/**<h2 className="title-effect">Accélérer la transition énergétique avec des solutions robustes et sur mesure.</h2>*/}
          
        </div> 
        <p>Au cœur des installations solaires, la conversion et l’injection d’énergie exigent une fiabilité sans faille. Notre gamme de transformateurs spéciaux dédiés au photovoltaïque est spécialement conçue pour relever ces défis techniques : </p>
        <p>Chez SACEM Industries, nous mettons notre expertise industrielle au service des producteurs d'énergies renouvelables pour bâtir un réseau électrique plus vert, stable et performant.</p>
        <p>📍 Découvrez nos solutions adaptées à vos projets solaires en nous contactant directement ou via notre site.</p>
       
       
     
       
      </div>  
    </div>
     <div className="row">
      <div className="col-lg-4 col-md-4 col-sm-4">
        <div className="feature-text left-icon mt-50 xs-mt-20">
          <div className="feature-icon">
            <span className=" theme-color" aria-hidden="true" />
          </div>              
          <div className="feature-info">
            <h5 className="text-back">Résistance aux contraintes sévères</h5>
            <p>support des régimes cycliques de production, des températures élevées et des fluctuations d'ensoleillement.</p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4 col-sm-4">
        <div className="feature-text left-icon mt-50 xs-mt-20">
          <div className="feature-icon">
            <span className=" theme-color" aria-hidden="true" />
          </div>              
          <div className="feature-info">
            <h5 className="text-back">Compatibilité avec les onduleurs</h5>
            <p>conception optimisée pour gérer les harmoniques et garantir un rendement maximal. </p>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4 col-sm-4">
        <div className="feature-text left-icon mt-50 xs-mt-20">
          <div className="feature-icon">
            <span className=" theme-color" aria-hidden="true" />
          </div>              
          <div className="feature-info">
            <h5 className="text-back">Sécurité & durabilité </h5>
            <p>continuité de service éprouvée pour sécuriser la rentabilité des centrales solaires. </p>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</section>

{/** */}
<section className="page-section-ptb">
  <div className="container">
    
    <div className="row">
      <div className="col-lg-4 col-md-4">
        <div className="pricing-table boxed" style={{borderTopColor:"#329BD1",minHeight:"260px"}}>
          <div className="pricing-top">
            <div className="pricing-title">
              <h3 className="mb-15">Résistance aux contraintes sévères</h3>
              <p>support des régimes cycliques de production, des températures élevées et des fluctuations d'ensoleillement.</p>
            </div>
           
            
          </div>
          
        </div>
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="pricing-table boxed" style={{borderTopColor:"green",minHeight:"260px"}}>
          <div className="pricing-top">
            <div className="pricing-title">
              <h3 className="mb-15">Compatibilité avec les onduleurs</h3>
              <p>conception optimisée pour gérer les harmoniques et garantir un rendement maximal.</p>
            </div>
            
            
          </div>
         
        </div> 
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="pricing-table boxed" style={{borderTopColor:"red",minHeight:"260px"}}>
          <div className="pricing-top">
            <div className="pricing-title">
              <h3 className="mb-15">Sécurité & durabilité</h3>
              <p>continuité de service éprouvée pour sécuriser la rentabilité des centrales solaires. </p>
            </div>
            
            
          </div>
         
        </div> 
      </div>
    </div>
  </div>
</section>

{/** */}



    </div>
  );
};
export default Fortest2;
